// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0241e942","256":"d62a67f0","395":"84106dc9","455":"ed45e55e","659":"f9dfb8e0","899":"5adb339b","977":"4a8016a4"}[chunkId] + ".chunk.js";
};